import { useQuery } from '@tanstack/react-query'

import { env } from '@/config/env'
import { systemApi } from '@/lib/api'
import { queryKeys } from '@/lib/queryClient'

/**
 * The status cluster polls, because the interesting states (GitHub rate-limited, database
 * unreachable) appear without any user action. The backend caches its GitHub probe, so
 * polling here does not consume the rate limit it reports on.
 */
export function useSystemStatus() {
  return useQuery({
    queryKey: queryKeys.system,
    queryFn: systemApi.status,
    refetchInterval: env.pollIntervalMs,
    staleTime: env.pollIntervalMs / 2,
  })
}

export function useToolCatalog() {
  return useQuery({
    queryKey: queryKeys.tools,
    queryFn: systemApi.tools,
    staleTime: 5 * 60_000, // The catalog changes on deploy, not during a session.
  })
}
